/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();



/* SHIPPING BAR */
function updateFreeShippingBar(cart) {
    const container = document.querySelector('#free-shipping-bar');
    if (!container) return;

    const threshold = parseInt(container.getAttribute('data-threshold'));
    const msgBeforeTemplate = container.getAttribute('data-msg-before');
    const msgAfter = container.getAttribute('data-msg-after');
    
    const progressBar = document.querySelector('#free-shipping-progress');
    const textContainer = document.querySelector('#free-shipping-text');

    const total = cart.total_price;
    const remaining = threshold - total;
    const percent = Math.min((total / threshold) * 100, 100);

    // 1. Update de la barre
    if (progressBar) {
      progressBar.style.width = percent + '%';
    }

    // 2. Update du texte et du montant
    if (textContainer) {
      if (remaining > 0) {
        // Formatage du prix restant
        let formattedRemaining = Shopify.formatMoney(remaining, theme.moneyFormat || "${{amount}} €");
        
        // Nettoyage du format (Espace pour les milliers comme demandé précédemment)
        formattedRemaining = formattedRemaining.replace('.', ' ');

        // Injection du montant dans le template de message "Before"
        const finalMessage = msgBeforeTemplate.replace('[amount]', formattedRemaining);
        textContainer.innerHTML = `<span>${finalMessage}</span>`;
      } else {
        // Switch vers le message de succès
        textContainer.innerHTML = `<span>${msgAfter}</span>`;
      }
    }
  }

  // Écouteur pour Expanse (Archetype themes)
  document.addEventListener('cart:updated', function(evt) {
    if (evt.detail && evt.detail.cart) {
      updateFreeShippingBar(evt.detail.cart);
    }
  });

  // Sécurité pour certains déclencheurs AJAX
  document.addEventListener('ajaxProduct:added', function() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => updateFreeShippingBar(cart));
  });